<div class="form" [ngClass]="{'is-overlay': isLoadingCities$ | async}" [formGroup]="form">
  <div class="form__overlay" *ngIf="isLoadingCities$ | async">
    <mat-spinner color="accent"></mat-spinner>
  </div>

  <ng-container *ngIf="cities$ | async as cities; else emptyAddress">
    <div class="form__col _md">
      <mat-form-field appearance="outline">
        <mat-label i18n="@@City">City</mat-label>
        <mat-select #deliveryCitySelect formControlName="city">
          <mat-option value="{{ city.name }}" *ngFor="let city of cities; let i = index" (onSelectionChange)="onChangeCityOption($event, city)">{{ city.name }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.city.hasError('required')" i18n="@@ErrorMessageRequired">Required</mat-error>
      </mat-form-field>
    </div>

    <div class="form__col _md">
      <mat-form-field appearance="outline">
        <mat-label i18n="@@Street">Street</mat-label>
        <mat-select formControlName="street">
          <mat-option>
            <ngx-mat-select-search
              #streetFilter
              [clearSearchInput]="false"
              placeholderLabel="Search"
              i18n-placeholderLabel="@@Search"
              noEntriesFoundLabel="No matches found"
              i18n-noEntriesFoundLabel="@@NoMatchesFound"
            ></ngx-mat-select-search>
          </mat-option>
          <cdk-virtual-scroll-viewport itemSize="42" minBufferPx="200" maxBufferPx="400" [style.height.px]="5*42" class="example-viewport">
            <mat-option
              (onSelectionChange)="onChangeStreet($event, street)"
              [value]="street.name"
              *cdkVirtualFor="let street of selectCity?.streets | filter:'name':streetFilter.value | sortString: 'name'"
            >{{ street.name }}</mat-option>
          </cdk-virtual-scroll-viewport>
          <mat-option hidden *ngIf="selectStreetName" value="{{ selectStreetName }}">{{ selectStreetName }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.street.hasError('required')" i18n="@@ErrorMessageRequired">Required</mat-error>
      </mat-form-field>
    </div>

    <div class="form__col _sm">
      <app-ez-input>
        <input appEzInput
               type="text"
               formControlName="house"
               name="house"
               maxlength="10"
               data-testid="house"
        >
        <ng-container ezLabel i18n="@@House">House</ng-container>
        <ng-container ezError *ngIf="form.controls!.house!.hasError('required') && (form.controls!.house!.dirty || form.controls!.house!.touched)" i18n="@@ErrorMessageRequired">Required</ng-container>
      </app-ez-input>
    </div>

    <ng-container *ngIf="isFullView">
      <div class="form__col _sm">
        <app-ez-input>
          <input appEzInput
                 type="text"
                 formControlName="building"
                 name="building"
                 data-testid="building"
          >
          <ng-container ezLabel i18n="@@Building">Building</ng-container>
        </app-ez-input>
      </div>

      <div class="form__col _sm">
        <app-ez-input>
          <input appEzInput
                 type="text"
                 formControlName="porch"
                 name="porch"
                 data-testid="porch"
          >
          <ng-container ezLabel i18n="@@Porch">Porch</ng-container>
        </app-ez-input>
      </div>

      <div class="form__col _sm">
        <app-ez-input>
          <input appEzInput
                 type="text"
                 formControlName="flat"
                 name="flat"
                 data-testid="flat"
          >
          <ng-container ezLabel i18n="@@Flat">Flat</ng-container>
        </app-ez-input>
      </div>

      <div class="form__col _sm">
        <app-ez-input>
          <input appEzInput
                 type="text"
                 formControlName="floor"
                 name="floor"
                 data-testid="floor"
          >
          <ng-container ezLabel i18n="@@Floor">Floor</ng-container>
        </app-ez-input>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #emptyAddress>
  <span *ngIf="(isLoadingCities$ | async) === false" class="button-panel-message small button-panel-message_error" i18n="@@AddressCitiesNotLoad">Failed to load list of cities. Delivery is not available. Select pickup.</span>
</ng-template>
